import React from 'react';
import IUniformNode, { deepenKey } from '../../../../../shared/quote-rendering/IUniformNode';
import { IPageNodeProps } from '../../../../../shared/quote-rendering/UniformNodeFactory';

export default class PageNode implements IUniformNode<React.ReactNode>{
    
    constructor(
        private readonly props: IPageNodeProps<React.ReactNode>
    ) {}

    renderWithManualKey() {
        return <div key={this.props.key}>
            {this.props.children.map(x => x.renderWithManualKey())}
        </div>;
    }

    render(seedKey:string) {
        return <div key={seedKey}>
            {this.props.children.map((x,i) => x.render(deepenKey(seedKey, i)))}
        </div>;
    }

}